import { TextareaHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import type { StyleType } from '~types/common';

import { S } from './style';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  register?: UseFormRegisterReturn;
  label?: string;
  hasError?: boolean;
  errorMessage?: string;
  inputCss?: StyleType;
  fullWidth?: boolean;
}
function Textarea({
  label,
  register,
  hasError,
  errorMessage,
  inputCss,
  fullWidth,
  ...props
}: Props) {
  return (
    <S.TextareaWrapper fullWidth={fullWidth}>
      {label && <S.Label htmlFor={props.id}>{label}</S.Label>}
      <S.StyledTextarea {...register} {...props} hasError={hasError} inputCss={inputCss} />
      {hasError && (
        <S.Error typography='midium120_C1' as='div'>
          {errorMessage && errorMessage}
        </S.Error>
      )}
    </S.TextareaWrapper>
  );
}

export default Textarea;
